import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navLinks = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/event',
    label: 'Event'
  }, {
    path: '/podcast',
    label: 'Podcast'
  }, {
    path: '/blog',
    label: 'Blog'
  }, {
    path: '/about',
    label: 'About'
  }, {
    path: '/volunteer',
    label: 'Volunteer'
  }, {
    path: '/contact',
    label: 'Contact'
  }];
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-69">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-70">
        <div className="flex items-center justify-between" data-id="element-71">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-72">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a2Q2ovLDuGctucudBaLTNL/Voices_with_victoria_Ndu.png" alt="Voices with Victoria" className="h-12 w-auto" data-id="element-73" />
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-74">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-medium transition-colors ${isActive(link.path) ? 'text-voices-gold' : 'text-gray-700 hover:text-voices-gold'}`} data-id="element-75">
                {link.label}
              </Link>)}
            <Link to="/event" className="bg-voices-gold text-white px-6 py-2 rounded-lg font-semibold hover:bg-yellow-600 transition-colors" data-id="element-76">
              Register Now
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-voices-navy" data-id="element-77">
            {isMenuOpen ? <XIcon size={28} data-id="element-78" /> : <MenuIcon size={28} data-id="element-79" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4" data-id="element-80">
            {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsMenuOpen(false)} className={`font-medium transition-colors ${isActive(link.path) ? 'text-voices-gold' : 'text-gray-700 hover:text-voices-gold'}`} data-id="element-81">
                {link.label}
              </Link>)}
            <Link to="/event" onClick={() => setIsMenuOpen(false)} className="bg-voices-gold text-white px-6 py-2 rounded-lg font-semibold hover:bg-yellow-600 transition-colors text-center" data-id="element-82">
              Register Now
            </Link>
          </nav>}
      </div>
    </header>;
}